<div class="chat-app" :class="{ 'mobile-chat-active': active_conversation_id }">
  <Navbar />

  <div class="page-wrapper chat-page-wrapper d-flex flex-grow-1 overflow-hidden">
    <Sidebar />

    <div class="hero-section w-100 chat-section d-flex flex-grow-1 overflow-hidden">
      <div class="chat-container chat-viewport-container p-0 w-100 d-flex flex-grow-1 overflow-hidden">
        <div class="row g-0 h-100 flex-nowrap">

          <div
            class="col-12 col-lg-4 col-xl-3 conversations-sidebar d-flex flex-column overflow-hidden position-relative"
            :class="{ 'd-none d-lg-flex': active_conversation_id }"
          >
            <div class="sidebar-header-chat d-flex align-items-center justify-content-between flex-shrink-0">
              <h5 class="sidebar-title fw-bold mb-0">Chats</h5>
              <div class="d-flex align-items-center gap-2">
                <button class="oc-icon-btn" title="More options"><i class="fas fa-ellipsis-v"></i></button>
                <button class="oc-icon-btn accent" title="New Chat" data-bs-toggle="modal" data-bs-target="#newConversationModal">
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="sidebar-search flex-shrink-0">
              <div class="oc-search-wrap d-flex align-items-center gap-2">
                <i class="fas fa-search"></i>
                <input type="text" placeholder="Search chats" v-model="search_query">
              </div>
            </div>

            <div class="conversations-list flex-grow-1 overflow-y-auto">
              <div v-if="!conversations_loaded" class="oc-loading d-flex flex-column align-items-center justify-content-center">
                <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
                <p>Loading chats…</p>
              </div>

              <div v-else-if="!conversations.length" class="sidebar-empty d-flex flex-column align-items-center justify-content-center text-center">
                <i class="fas fa-comments fa-3x"></i>
                <h6>No conversations yet</h6>
                <p>Start chatting with your colleagues</p>
                <button class="btn-oc-start" data-bs-toggle="modal" data-bs-target="#newConversationModal">
                  <i class="fas fa-plus me-1"></i>Start a chat
                </button>
              </div>

              <div v-else-if="filtered_conversations.length === 0" class="sidebar-empty d-flex flex-column align-items-center justify-content-center text-center">
                <i class="fas fa-search fa-3x"></i>
                <h6>No results</h6>
                <p>Try a different search term</p>
              </div>

              <div v-else>
                <a
                  v-for="conv in filtered_conversations" :key="conv.id"
                  href="#" class="conversation-item d-flex align-items-center"
                  :class="{ active: conv.id === active_conversation_id }"
                  @click.prevent="select_conversation(conv.id)"
                >
                  <div class="oc-avatar oc-avatar-md" :class="get_avatar_class(get_other_user(conv).name)">
                    {{ get_initials(get_other_user(conv).name) }}
                  </div>
                  <div class="conv-body flex-grow-1 text-start">
                    <div class="conv-name text-truncate" :class="{ unread: conv.unread_count > 0 }">
                      {{ get_other_user(conv).name }}
                    </div>
                    <div class="conv-preview text-truncate" :class="{ unread: conv.unread_count > 0 }">
                      {{ truncate_text(conv.last_message?.content || 'No messages yet', 40) }}
                    </div>
                  </div>
                  <div class="conv-meta d-flex flex-column align-items-end flex-shrink-0">
                    <span class="conv-time text-nowrap" :class="{ unread: conv.unread_count > 0 }">
                      {{ format_time_ago(conv.updated_at) }}
                    </span>
                    <span v-if="conv.unread_count > 0" class="conv-badge">
                      {{ conv.unread_count > 99 ? '99+' : conv.unread_count }}
                    </span>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <!-- /sidebar -->

          <section
            class="col-12 col-lg-8 col-xl-9 chat-panel d-flex flex-column"
            :class="{
              'd-none d-lg-flex': !active_conversation_id,
              'info-panel-open': show_info_panel
            }"
          >

            <!-- Welcome state -->
            <div v-if="!active_conversation_id" class="chat-welcome d-flex align-items-center justify-content-center h-100">
              <div class="chat-welcome-card text-center">
                <i class="fas fa-comments fa-4x"></i>
                <h3>Welcome to One Chat</h3>
                <p>Select a conversation or start a new one to message your colleagues.</p>
                <small class="mt-2 d-block"><i class="fas fa-lock me-1"></i>Messages are secured</small>
              </div>
            </div>

            <template v-else>

              <!-- Header -->
              <div class="chat-header d-flex align-items-center flex-shrink-0">
                <button class="oc-back-btn d-lg-none" @click="active_conversation_id = null" aria-label="Back">
                  <i class="fas fa-arrow-left"></i>
                </button>
                <div class="oc-avatar oc-avatar-lg" :class="get_avatar_class(get_other_user(active_conversation).name)">
                  {{ get_initials(get_other_user(active_conversation).name) }}
                </div>
                <div class="chat-header-info flex-grow-1 text-start ms-2">
                  <span class="chat-header-name fw-bold d-block text-truncate">
                    {{ get_other_user(active_conversation).name }}
                  </span>
                </div>
                <div class="d-flex gap-1 ms-auto">
                  <button class="oc-icon-btn" :class="{ accent: show_info_panel }" title="Conversation info" @click="show_info_panel = !show_info_panel">
                    <i class="fas fa-info-circle"></i>
                  </button>
                  <button
                    class="oc-icon-btn"
                    :class="{ accent: show_message_search }"
                    title="Search messages"
                    @click="toggle_message_search"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>

              <!-- In-conversation search bar -->
              <transition name="oc-search-slide">
                <div
                  v-if="show_message_search"
                  class="msg-search-bar d-flex align-items-center flex-shrink-0 gap-2 px-2 px-md-3 py-2 border-bottom"
                >
                  <!-- Input group -->
                  <div class="d-flex align-items-center flex-grow-1 gap-2 rounded-pill px-3 py-1 msg-search-input-wrap">
                    <i class="fas fa-search text-muted flex-shrink-0 msg-search-icon"></i>
                    <input
                      ref="msg_search_input"
                      type="text"
                      class="flex-grow-1 border-0 bg-transparent msg-search-input"
                      placeholder="Search in conversation…"
                      v-model="message_search_query"
                      @keydown.enter.exact.prevent="next_search_result"
                      @keydown.shift.enter.prevent="prev_search_result"
                      @keydown.esc="clear_message_search"
                    />
                    <span
                      v-if="message_search_query"
                      class="text-muted flex-shrink-0 d-none d-sm-inline msg-search-count"
                    >
                      <template v-if="message_search_matches.length">
                        {{ message_search_index + 1 }}&nbsp;/&nbsp;{{ message_search_matches.length }}
                      </template>
                      <template v-else>No results</template>
                    </span>
                  </div>

                  <!-- Result counter xs only -->
                  <span
                    v-if="message_search_query"
                    class="badge rounded-pill bg-secondary d-inline d-sm-none flex-shrink-0 msg-search-badge"
                  >
                    <template v-if="message_search_matches.length">
                      {{ message_search_index + 1 }}/{{ message_search_matches.length }}
                    </template>
                    <template v-else>0</template>
                  </span>

                  <!-- Prev -->
                  <button
                    class="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 p-0 msg-search-nav-btn"
                    title="Previous (Shift+Enter)"
                    :disabled="message_search_matches.length < 2"
                    @click="prev_search_result"
                  >
                    <i class="fas fa-chevron-up msg-search-nav-icon"></i>
                  </button>

                  <!-- Next -->
                  <button
                    class="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 p-0 msg-search-nav-btn"
                    title="Next (Enter)"
                    :disabled="message_search_matches.length < 2"
                    @click="next_search_result"
                  >
                    <i class="fas fa-chevron-down msg-search-nav-icon"></i>
                  </button>

                  <!-- Close -->
                  <button
                    class="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 p-0 msg-search-nav-btn"
                    title="Close (Esc)"
                    @click="clear_message_search"
                  >
                    <i class="fas fa-times msg-search-nav-icon"></i>
                  </button>
                </div>
              </transition>

              <!-- Pinned bar -->
              <div v-if="pinned_messages.length && !show_info_panel && !show_message_search" class="pinned-bar" @click="open_info_panel('pinned')">
                <div class="pinned-bar-strip d-flex align-items-center gap-2">
                  <div class="pinned-bar-line flex-shrink-0"></div>
                  <div class="pinned-bar-content flex-grow-1 text-start">
                    <span class="pinned-bar-label fw-bold d-block text-uppercase">
                      {{ pinned_messages.length }} pinned {{ pinned_messages.length === 1 ? 'message' : 'messages' }}
                    </span>
                    <span class="pinned-bar-preview d-block text-truncate">
                      {{ pinned_messages[pinned_messages.length - 1]?.content
                         || (pinned_messages[pinned_messages.length - 1]?.attachments?.length ? '📎 Attachment' : '—') }}
                    </span>
                  </div>
                  <i class="fas fa-chevron-right pinned-bar-chevron flex-shrink-0"></i>
                </div>
              </div>

              <!-- Messages area + info panel -->
              <div class="position-relative flex-grow-1 d-flex flex-column overflow-hidden">

                <!-- New messages banner -->
                <div
                  v-if="new_messages_banner"
                  class="new-messages-banner position-absolute d-flex align-items-center gap-2 text-nowrap"
                  @click="jump_to_bottom" role="button"
                >
                  <i class="fas fa-arrow-down"></i><span>New messages</span>
                </div>

                <!-- Scroll area -->
                <div ref="scroll_area" class="messages-area flex-grow-1">

                  <div v-if="messages_loading && !messages.length" class="oc-loading d-flex flex-column align-items-center justify-content-center">
                    <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
                    <p>Loading messages…</p>
                  </div>

                  <div v-else>
                    <div v-for="(item, i) in rendered_stream" :key="item._k ?? i">

                      <!-- Date stamp -->
                      <div v-if="item.kind === 'stamp'" class="date-stamp"><span>{{ item.when }}</span></div>

                      <!-- Unread divider -->
                      <div v-else-if="item.kind === 'unread'" class="unread-divider"><span>Unread Messages</span></div>

                      <div
                        v-else-if="item.kind === 'msg'"
                        class="message-row d-flex align-items-end"
                        :class="item.side === 'right' ? 'message-sent justify-content-end' : 'message-received justify-content-start'"
                        @touchstart.passive="handle_touch_start(item, $event)"
                        @touchend.passive="handle_touch_end"
                        @touchmove.passive="handle_touch_move"
                      >

                        <!-- Avatar — received messages only, sits outside hover zone -->
                        <div
                          v-if="item.side === 'left'"
                          class="oc-avatar oc-avatar-sm flex-shrink-0 me-2 mb-1 align-self-end"
                          :class="get_avatar_class(get_sender_name_by_id(item.id))"
                        >{{ get_initials(get_sender_name_by_id(item.id)) }}</div>

                        <!-- ── message-inner: single hover zone for toolbar + bubble ── -->
                        <div
                          class="message-inner d-flex flex-column"
                          @mouseenter="hovered_message_key = item._k"
                          @mouseleave="hovered_message_key = null"
                        >

                          <!-- ── Hover toolbar ── -->
                          <div
                            v-show="hovered_message_key === item._k || active_toolbar_key === item._k"
                            class="msg-hover-toolbar d-flex align-items-center mb-1"
                            :class="item.side === 'right' ? 'align-self-end' : 'align-self-start'"
                            @click.stop
                          >
                            <div class="msg-tb-pill d-flex align-items-center gap-1 px-2 py-1">

                              <!-- Quick emoji buttons (always visible) -->
                              <button
                                v-for="e in quick_emojis" :key="e"
                                class="emoji-btn-tb"
                                :class="{ 'emoji-btn-active': my_reaction_for(item) === e }"
                                :title="e"
                                @click.stop="send_reaction(item, e, $event)"
                              >{{ e }}</button>

                              <!-- More emojis (emoji-mart picker) -->
                              <div class="position-relative">
                                <button
                                  class="msg-tb-btn msg-tb-btn-emoji"
                                  title="More reactions"
                                  @click.stop="toggle_emoji_picker(item, $event)"
                                >
                                  <i class="far fa-smile"></i>
                                </button>
                                <div
                                  v-if="emoji_picker_key === item._k"
                                  class="emoji-picker-popup position-absolute"
                                  :class="item.side === 'left' ? 'emoji-picker-left' : 'emoji-picker-right'"
                                  @click.stop
                                >
                                  <EmojiPicker
                                    :native="true"
                                    :hide-search="false"
                                    :hide-group-names="false"
                                    :disable-sticky-group-names="false"
                                    theme="light"
                                    @select="(emoji) => { send_reaction(item, emoji.i, null); emoji_picker_key = null; }"
                                  />
                                </div>
                              </div>

                              <div class="msg-tb-divider mx-1"></div>

                              <!-- Reply — received messages only in the pill -->
                              <button
                                v-if="item.side === 'left'"
                                class="msg-tb-btn"
                                title="Reply"
                                @click.stop="set_reply_to(item); active_toolbar_key = null"
                              >
                                <i class="fas fa-reply"></i>
                              </button>

                              <!-- Edit — sent messages only in the pill -->
                              <button
                                v-if="item.side === 'right'"
                                class="msg-tb-btn"
                                title="Edit"
                                @click.stop="start_edit(item); active_toolbar_key = null"
                              >
                                <i class="fas fa-pencil-alt"></i>
                              </button>

                              <!-- ⋯ More actions menu -->
                              <div class="position-relative">
                                <button
                                  class="msg-tb-btn msg-tb-btn-dots"
                                  title="More actions"
                                  @click.stop="toggle_more_menu(item, $event)"
                                >
                                  <i class="fas fa-ellipsis-h"></i>
                                </button>

                                <div
                                  v-if="active_toolbar_key === item._k"
                                  class="msg-more-menu position-absolute"
                                  :class="[
                                    item.side === 'left' ? 'msg-more-menu-left' : 'msg-more-menu-right',
                                    toolbar_menu_direction[item._k] === 'down' ? 'msg-more-menu-down' : 'msg-more-menu-up'
                                  ]"
                                  @click.stop
                                >
                                  <!-- Reply — in more menu for sent messages only -->
                                  <button
                                    v-if="item.side === 'right'"
                                    class="msg-more-item d-flex align-items-center gap-2 w-100"
                                    @click.stop="set_reply_to(item); active_toolbar_key = null"
                                  >
                                    <i class="fas fa-reply fa-fw"></i>
                                    <span>Reply</span>
                                  </button>

                                  <!-- Pin / Unpin — both sides -->
                                  <button
                                    class="msg-more-item d-flex align-items-center gap-2 w-100"
                                    @click.stop="toggle_pin(item); active_toolbar_key = null"
                                  >
                                    <i class="fas fa-thumbtack fa-fw"></i>
                                    <span>{{ item.is_pinned ? 'Unpin message' : 'Pin message' }}</span>
                                  </button>

                                  <!-- Delete — own messages only -->
                                  <template v-if="item.side === 'right'">
                                    <div class="msg-more-divider"></div>
                                    <button
                                      class="msg-more-item danger d-flex align-items-center gap-2 w-100"
                                      @click.stop="confirm_delete(item); active_toolbar_key = null"
                                    >
                                      <i class="fas fa-trash fa-fw"></i>
                                      <span>Delete message</span>
                                    </button>
                                  </template>
                                </div>
                              </div>

                            </div>
                          </div>
                          <!-- /toolbar -->

                          <!-- ── Message bubble ── -->
                          <div
                            class="message-bubble"
                            :class="[
                              item.edited_at ? 'message-updated-flash' : '',
                              item.side === 'right' ? 'align-self-end' : 'align-self-start'
                            ]"
                            :key="item.id + '-' + item.edited_at"
                            @click="handle_bubble_click(item)"
                          >

                            <!-- Reply / quote preview -->
                            <div
                              v-if="item.reply_to"
                              class="reply-preview"
                              :class="item.side === 'right' ? 'reply-preview-sent' : 'reply-preview-received'"
                            >
                              <span class="reply-preview-sender">
                                {{ item.reply_to.sender ? `${item.reply_to.sender.first_name || ''} ${item.reply_to.sender.last_name || ''}`.trim() || item.reply_to.sender.username : 'Unknown' }}
                              </span>
                              <span class="reply-preview-text d-block text-truncate">
                                <template v-if="item.reply_to.content">{{ truncate_text(item.reply_to.content, 60) }}</template>
                                <template v-else-if="item.reply_to.attachments && item.reply_to.attachments.length">📎 Attachment</template>
                                <template v-else>—</template>
                              </span>
                            </div>

                            <!-- Attachments -->
                            <div v-if="item.attachments && item.attachments.length" class="d-flex flex-column gap-2 mb-1">
                              <div v-for="file in item.attachments" :key="file.id">

                                <div v-if="is_image_file(file.file_name)" class="chat-img-wrapper position-relative d-inline-block" @click.stop="preview_chat_file(file)" role="button">
                                  <img :src="file.file_url" :alt="file.file_name" class="chat-inline-img" loading="lazy" @load="scroll_to_bottom" />
                                  <div class="chat-img-overlay position-absolute d-flex align-items-center justify-content-center">
                                    <i class="fas fa-expand-alt"></i>
                                  </div>
                                </div>

                                <div v-else-if="is_video_file(file.file_name)">
                                  <video :src="file.file_url" class="chat-inline-video" controls preload="metadata" playsinline @play="stop_other_media($event)"></video>
                                </div>

                                <div v-else-if="is_audio_file(file.file_name)" class="chat-audio-wrapper">
                                  <div class="chat-audio-header d-flex align-items-center gap-2 mb-2">
                                    <div class="chat-audio-icon"><i class="fas fa-music"></i></div>
                                    <span class="chat-audio-name text-truncate">{{ file.file_name }}</span>
                                  </div>
                                  <audio :src="file.file_url" class="chat-inline-audio w-100" controls preload="metadata" @play="stop_other_media($event)"></audio>
                                </div>

                                <div v-else class="attach-card" @click.stop="preview_chat_file(file)" role="button">
                                  <div class="attach-icon"><i :class="file_icon_chat(file.file_name)"></i></div>
                                  <div class="flex-grow-1 overflow-hidden">
                                    <div class="attach-name fw-semibold text-truncate">{{ file.file_name }}</div>
                                    <div class="attach-hint">Tap to preview</div>
                                  </div>
                                  <a :href="file.file_url" :download="file.file_name" class="attach-dl-btn" title="Download" @click.stop>
                                    <i class="fas fa-download"></i>
                                  </a>
                                </div>

                              </div>
                            </div>

                            <!-- Edit area — replaces bubble content when editing -->
                            <div v-if="editing_message_key === item._k" class="edit-area w-100" @click.stop>
                              <textarea
                                v-model="edit_draft"
                                class="w-100"
                                rows="3"
                                @keydown.enter.exact.prevent="submit_edit(item)"
                                @keydown.esc="cancel_edit"
                              ></textarea>
                              <!-- Compact icon actions -->
                              <div class="d-flex align-items-center justify-content-end gap-2 mt-1">
                                <span class="edit-hint d-none d-md-block">Enter to save · Esc to cancel</span>
                                <button class="edit-icon-btn edit-icon-cancel" title="Cancel (Esc)" @click="cancel_edit">
                                  <i class="fas fa-times"></i>
                                </button>
                                <button class="edit-icon-btn edit-icon-save" title="Save (Enter)" :disabled="!edit_draft.trim() || saving_edit" @click="submit_edit(item)">
                                  <i v-if="saving_edit" class="fas fa-spinner fa-spin"></i>
                                  <i v-else class="fas fa-check"></i>
                                </button>
                              </div>
                            </div>

                            <!-- Text -->
                            <p
                              v-else-if="item.text"
                              class="bubble-text mb-0"
                              :class="{ 'msg-search-active-bubble': message_search_matches[message_search_index] === item._k }"
                              v-html="highlight_text(item.text)"
                            ></p>

                            <!-- Meta -->
                            <div class="bubble-meta d-flex align-items-center justify-content-end gap-1 mt-1">
                              <span v-if="item.edited_at" class="bubble-edited">edited</span>
                              <span class="bubble-time">{{ item.timestamp }}</span>
                              <i v-if="item.side === 'right'" class="fas fa-check-double tick-icon"></i>
                              <i v-if="item.is_pinned" class="fas fa-thumbtack pin-indicator"></i>
                            </div>

                            <!-- Reaction chips -->
                            <div v-if="item.reactions && item.reactions.length" class="reactions-row d-flex flex-wrap gap-1 mt-1">
                              <button
                                v-for="rg in item.reactions" :key="rg.emoji"
                                class="reaction-chip"
                                :class="{ 'reaction-chip-mine': rg.reacted_by_me }"
                                :title="`${rg.count} reaction${rg.count > 1 ? 's' : ''}`"
                                @click.stop="send_reaction(item, rg.emoji, $event)"
                              >
                                <span class="reaction-emoji">{{ rg.emoji }}</span>
                                <span class="reaction-count">{{ rg.count }}</span>
                              </button>
                            </div>

                          </div>
                          <!-- /bubble -->

                        </div>
                        <!-- /message-inner -->

                      </div>
                      <!-- /message-row -->

                    </div>
                  </div>
                </div>
                <!-- /scroll_area -->

                <!-- Info panel -->
                <div class="chat-info-panel d-flex flex-column overflow-hidden" :class="{ open: show_info_panel }">
                  <div class="info-panel-header d-flex align-items-center justify-content-between flex-shrink-0">
                    <span class="info-panel-title fw-bold m-0">Conversation Info</span>
                    <button class="oc-icon-btn" @click="show_info_panel = false" title="Close"><i class="fas fa-times"></i></button>
                  </div>

                  <div class="info-tabs d-flex flex-shrink-0">
                    <button class="info-tab-btn" :class="{ active: info_tab === 'profile' }" @click="info_tab = 'profile'">
                      <i class="fas fa-user d-block mb-1"></i>Profile
                    </button>
                    <button class="info-tab-btn" :class="{ active: info_tab === 'pinned' }" @click="info_tab = 'pinned'">
                      <i class="fas fa-thumbtack d-block mb-1"></i>Pinned
                      <span v-if="pinned_messages.length" class="ms-1 badge rounded-pill bg-danger">{{ pinned_messages.length }}</span>
                    </button>
                    <button class="info-tab-btn" :class="{ active: info_tab === 'files' }" @click="info_tab = 'files'">
                      <i class="fas fa-paperclip d-block mb-1"></i>Files
                    </button>
                  </div>

                  <div v-if="info_tab === 'profile'" class="info-panel-body flex-grow-1 overflow-y-auto">
                    <div class="info-user-card text-center">
                      <div class="oc-avatar oc-avatar-lg mx-auto" :class="get_avatar_class(get_other_user(active_conversation).name)">
                        {{ get_initials(get_other_user(active_conversation).name) }}
                      </div>
                      <div class="info-user-name fw-bold mt-2">{{ get_other_user(active_conversation).name }}</div>
                      <div class="info-user-meta">Team member</div>
                    </div>
                    <div class="d-flex gap-2 mt-3">
                      <div class="info-stat-card flex-fill text-center">
                        <div class="info-stat-num fw-bold">{{ messages.length }}</div>
                        <div class="info-stat-label">Messages</div>
                      </div>
                      <div class="info-stat-card flex-fill text-center">
                        <div class="info-stat-num fw-bold">{{ pinned_messages.length }}</div>
                        <div class="info-stat-label">Pinned</div>
                      </div>
                      <div class="info-stat-card flex-fill text-center">
                        <div class="info-stat-num fw-bold">{{ shared_files_count }}</div>
                        <div class="info-stat-label">Files</div>
                      </div>
                    </div>
                    <div class="d-flex flex-column gap-2 mt-3">
                      <button class="info-action-btn d-flex align-items-center gap-2 w-100 text-start" @click="info_tab = 'pinned'">
                        <i class="fas fa-thumbtack"></i><span class="flex-grow-1">View pinned messages</span><i class="fas fa-chevron-right text-muted"></i>
                      </button>
                      <button class="info-action-btn d-flex align-items-center gap-2 w-100 text-start" @click="info_tab = 'files'">
                        <i class="fas fa-paperclip"></i><span class="flex-grow-1">Shared files</span><i class="fas fa-chevron-right text-muted"></i>
                      </button>
                    </div>
                  </div>

                  <div v-else-if="info_tab === 'pinned'" class="info-panel-body flex-grow-1 overflow-y-auto">
                    <div v-if="!pinned_messages.length" class="info-empty-state d-flex flex-column align-items-center text-center">
                      <i class="fas fa-thumbtack"></i>
                      <p>No pinned messages yet.</p>
                    </div>
                    <div v-else>
                      <div v-for="msg in pinned_messages" :key="msg.id" class="info-pin-item d-flex align-items-start gap-2">
                        <div class="info-pin-line flex-shrink-0"></div>
                        <div class="info-pin-body flex-grow-1">
                          <span class="info-pin-sender fw-bold d-block">{{ msg.sender.first_name }} {{ msg.sender.last_name }}</span>
                          <span class="info-pin-text d-block">{{ msg.content || (msg.attachments?.length ? '📎 Attachment' : '') }}</span>
                          <span class="info-pin-time d-block mt-1">{{ format_time(msg.created_at) }}</span>
                        </div>
                        <button class="info-unpin-btn flex-shrink-0 align-self-center" title="Unpin" @click="toggle_pin_by_msg(msg)">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div v-else-if="info_tab === 'files'" class="info-panel-body flex-grow-1 overflow-y-auto">
                    <div v-if="!shared_files.length" class="info-empty-state d-flex flex-column align-items-center text-center">
                      <i class="fas fa-paperclip"></i>
                      <p>No files shared yet.<br>Attach a file to a message to see it here.</p>
                    </div>
                    <div v-else>
                      <a
                        v-for="file in shared_files" :key="file.id"
                        href="#" class="info-file-item d-flex align-items-center gap-2 text-decoration-none"
                        @click.prevent="preview_chat_file(file)"
                      >
                        <div class="info-file-icon d-flex align-items-center justify-content-center flex-shrink-0">
                          <i :class="file_icon_chat(file.file_name)"></i>
                        </div>
                        <div class="overflow-hidden">
                          <div class="info-file-name fw-semibold text-truncate">{{ file.file_name }}</div>
                          <div class="info-file-meta">{{ format_date(file.created_at) }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <!-- /info panel -->

              </div>
              <!-- /relative wrapper -->

              <div ref="scroll_anchor_el" class="chat-scroll-anchor"></div>

              <!-- Attachment preview strip -->
              <div v-if="selected_file" class="attach-preview-strip d-flex align-items-center flex-shrink-0">
                <div v-if="is_image_file(selected_file.name) && selected_file_preview_url" class="attach-preview-thumb flex-shrink-0">
                  <img :src="selected_file_preview_url" alt="preview" />
                </div>
                <div v-else class="attach-preview-icon d-flex align-items-center justify-content-center flex-shrink-0">
                  <i class="fas fa-paperclip"></i>
                </div>
                <span class="attach-preview-name flex-grow-1 text-truncate">{{ selected_file.name }}</span>
                <button class="attach-preview-rm d-flex align-items-center justify-content-center flex-shrink-0" @click="remove_selected_file">
                  <i class="fas fa-times"></i>
                </button>
              </div>

              <!-- Reply-to strip -->
              <div v-if="reply_to_message" class="reply-to-strip d-flex align-items-center flex-shrink-0">
                <div class="reply-to-strip-line flex-shrink-0"></div>
                <div class="reply-to-strip-body flex-grow-1 overflow-hidden">
                  <span class="reply-to-strip-sender d-block fw-bold">{{ reply_to_message.sender_name }}</span>
                  <span class="reply-to-strip-text d-block text-truncate">
                    <template v-if="reply_to_message.content">{{ truncate_text(reply_to_message.content, 70) }}</template>
                    <template v-else-if="reply_to_message.attachments && reply_to_message.attachments.length">📎 Attachment</template>
                    <template v-else>—</template>
                  </span>
                </div>
                <button class="reply-to-strip-close flex-shrink-0" title="Cancel reply" @click="clear_reply_to">
                  <i class="fas fa-times"></i>
                </button>
              </div>

              <!-- Message input -->
              <div class="message-input-bar d-flex align-items-end flex-shrink-0">
                <button class="oc-input-btn" title="Emoji" disabled><i class="far fa-smile"></i></button>
                <input type="file" ref="file_input" class="d-none" @change="handle_file_select">
                <button class="oc-input-btn" :class="{ 'has-file': selected_file }" title="Attach file" @click="$refs.file_input.click()">
                  <i class="fas fa-paperclip"></i>
                </button>
                <div class="oc-input-wrap d-flex align-items-end flex-grow-1">
                  <textarea
                    v-model.trim="draft"
                    class="oc-textarea"
                    placeholder="Send a message…"
                    rows="1"
                    :disabled="sending_message"
                    @keydown.enter.exact.prevent="send"
                    @input="auto_resize_textarea"
                  ></textarea>
                  <button class="oc-send-btn" :disabled="(!draft && !selected_file) || sending_message" @click="send" title="Send">
                    <i v-if="sending_message" class="fas fa-spinner fa-spin"></i>
                    <i v-else class="fas fa-paper-plane"></i>
                  </button>
                </div>
              </div>

            </template>
          </section>
          <!-- /chat-panel -->

        </div>
      </div>
    </div>
  </div>

  <!-- ══════════ Mobile action sheet (Teleport) ══════════ -->
  <Teleport to="body">
    <div
      v-if="mobile_action_item"
      class="mobile-action-sheet-overlay position-fixed d-flex align-items-end"
      @click.self="mobile_action_item = null"
    >
      <div class="mobile-action-sheet w-100">
        <div class="action-sheet-handle mx-auto"></div>

        <div class="action-sheet-preview">
          <div class="action-sheet-preview-text text-truncate">
            "{{ truncate_text(mobile_action_item.text || '📎 Attachment', 60) }}"
          </div>
        </div>

        <!-- Mobile quick-react row -->
        <div class="action-sheet-emoji-row d-flex justify-content-center gap-2 px-4 py-2">
          <button
            v-for="e in quick_emojis" :key="e"
            class="emoji-btn"
            :class="{ 'emoji-btn-active': my_reaction_for(mobile_action_item) === e }"
            @click="send_reaction(mobile_action_item, e, null); mobile_action_item = null"
          >{{ e }}</button>
        </div>

        <button class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="set_reply_to(mobile_action_item); mobile_action_item = null">
          <i class="fas fa-reply"></i>Reply
        </button>
        <button class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="toggle_pin(mobile_action_item); mobile_action_item = null">
          <i class="fas fa-thumbtack"></i>
          {{ mobile_action_item.is_pinned ? 'Unpin message' : 'Pin message' }}
        </button>
        <button v-if="mobile_action_item.side === 'right'"
          class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="start_edit(mobile_action_item); mobile_action_item = null">
          <i class="fas fa-pencil-alt"></i>Edit message
        </button>
        <button v-if="mobile_action_item.side === 'right'"
          class="action-sheet-btn danger d-flex align-items-center gap-3 w-100 text-start"
          @click="confirm_delete(mobile_action_item); mobile_action_item = null">
          <i class="fas fa-trash"></i>Delete message
        </button>
        <button class="action-sheet-btn d-flex align-items-center gap-3 w-100 text-start"
          @click="mobile_action_item = null">
          <i class="fas fa-times"></i>Cancel
        </button>
      </div>
    </div>
  </Teleport>

  <!-- ══════════ New Conversation modal ══════════ -->
  <div class="modal fade" id="newConversationModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-new-conv">
      <div class="modal-content">
        <div class="modal-header oc-modal-header">
          <h5 class="oc-modal-title fw-bold mb-0 gradient-text">New Conversation</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body oc-modal-body">
          <div class="oc-modal-search">
            <div class="oc-modal-search-inner d-flex align-items-center gap-2">
              <i class="fas fa-search flex-shrink-0"></i>
              <input type="text" class="flex-grow-1" placeholder="Search contacts…" v-model="contact_search_query" :disabled="users_loading">
            </div>
          </div>
          <div v-if="users_loading" class="oc-loading d-flex flex-column align-items-center justify-content-center py-5">
            <div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>
            <p>Loading contacts…</p>
          </div>
          <div v-else-if="filtered_users.length === 0" class="sidebar-empty d-flex flex-column align-items-center justify-content-center text-center py-5">
            <i class="fas fa-users fa-3x"></i>
            <h6>{{ contact_search_query ? 'No contacts found' : 'No contacts available' }}</h6>
            <p v-if="contact_search_query">Try a different search term</p>
          </div>
          <div v-else class="oc-contact-list">
            <a
              v-for="user in filtered_users" :key="user.id"
              href="#" class="oc-contact-item d-flex align-items-center gap-3 text-decoration-none"
              :class="{ active: new_conversation_user_id === user.id }"
              @click.prevent="new_conversation_user_id = user.id"
            >
              <div class="oc-avatar oc-avatar-md flex-shrink-0" :class="get_avatar_class(`${user.first_name} ${user.last_name}`)">
                {{ get_initials(`${user.first_name} ${user.last_name}`) }}
              </div>
              <div class="flex-grow-1 overflow-hidden">
                <div class="oc-contact-name fw-semibold">{{ user.first_name }} {{ user.last_name }}</div>
                <div class="oc-contact-email text-truncate">{{ user.email }}</div>
              </div>
              <i v-if="new_conversation_user_id === user.id" class="fas fa-check-circle oc-contact-check flex-shrink-0"></i>
            </a>
          </div>
        </div>
        <div class="modal-footer oc-modal-footer">
          <button type="button" class="btn-oc-ghost btn" data-bs-dismiss="modal">Cancel</button>
          <button class="btn-oc-primary btn" :disabled="!new_conversation_user_id || starting_conversation" @click="start_new_conversation">
            <i v-if="starting_conversation" class="fas fa-spinner fa-spin me-2"></i>
            {{ starting_conversation ? 'Starting…' : 'Start Chat' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ══════════ Delete Message modal ══════════ -->
  <div class="modal fade" id="deleteMessageModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="oc-modal-title fw-bold mb-0">Delete message?</h6>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="oc-modal-delete-body p-3">
          <p class="small mb-0 oc-modal-delete-text">This will permanently remove the message for everyone.</p>
        </div>
        <div class="d-flex gap-2 justify-content-end p-3 oc-modal-delete-footer">
          <button type="button" class="btn-oc-ghost btn" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn-oc-danger btn" :disabled="deleting_message" @click="execute_delete">
            <i v-if="deleting_message" class="fas fa-spinner fa-spin me-1"></i>Delete
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ══════════ File Preview ══════════ -->
  <div v-if="preview_modal" @click.self="preview_modal = false">
    <FilePreviewComponent
      :presigned_url="preview_file_url"
      @close="close_the_file_preview"
      :file_name="preview_file_name"
      :shared_access_level="preview_file_access_level"
    />
  </div>

</div>
<PoweredBy />